var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.attacks.length)?_c('a-timeline',_vm._l((_vm.attacks),function(a){return _c('a-timeline-item',{key:a.datetime+a.content},[_vm._v("["+_vm._s(_vm._f("moment")(a.datetime,'YYYY-MM-DD HH:mm:ss'))+"] "+_vm._s(a.content)+" ")])}),1):_c('div',[_c('a-empty')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }